import React, {useState} from 'react'
import {TournamentShortComponent} from "./ligaComponents";
import {Paginator} from "primereact/paginator";
import PropTypes from "prop-types";

function ProfilTurnierArea({turniereAktuell, turniereAbgeschlossen}) {

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(5);

    const abgeschlossenRows = () => {
        let returnRows = [];
        for(let i = first; i < (first + rows) ; i++) {
            let turnier = turniereAbgeschlossen[i];
            if( turnier !== undefined) {
                returnRows.push(turnier);
            }
        }
        return returnRows;
    }

    return <div className="col-12 md:col-12 lg:col-4" style={{padding: 10}}>
        <div className="ligashortoverview"
             style={{height: "100%", borderLeft: "10px solid #b3ccff", textAlign: "left"}}>
            <h3>Turnierinformationen</h3>
            <h4>Aktive Turniere</h4>
            <div className="grid" style={{marginTop: "20px"}}>
                <TournamentShortComponent tournaments={turniereAktuell} showDetails={false}/>
            </div>
            <h4>Abgeschlossene Turniere</h4>
            <Paginator first={first} rows={rows} totalRecords={turniereAbgeschlossen.length} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={(e) => {
                setFirst(e.first);
                setRows(e.rows);
            }}>></Paginator>
            <div className="grid" style={{marginTop: "20px"}}>
                <TournamentShortComponent tournaments={abgeschlossenRows()} showDetails={false}/>
            </div>
        </div>
    </div>
}

ProfilTurnierArea.propTypes = {
    turniereAktuell: PropTypes.array.isRequired,
    turniereAbgeschlossen: PropTypes.array.isRequired,
};

export default ProfilTurnierArea;
